import FavCityButton from "../fav-city-button/FavCityButton";
import iconLocation from "@/img/location-simple.svg";
import searchIcon from "@/img/search-icon.svg";

import "./style.scss";

type SearchBarResultProps = {
	openModal: () => void;
	location: string;
	isCurrentLocation?: boolean;
	cityNameAr: string;
	cityNameEn: string;
	locationId: string;
	obsRead?: string;
	showFavButton: boolean;
};

export const SearchBarResult = ({
	isCurrentLocation,
	location,
	cityNameAr,
	cityNameEn,
	locationId,
	obsRead,
	showFavButton,
	openModal,
}: SearchBarResultProps) => {
	const handleClickToOpenModal = () => {
		openModal();
	};

	return (
		<div
			className="search-bar-result-container"
			onClick={(e) => {
				if (e.target === e.currentTarget) {
					handleClickToOpenModal();
				}
			}}
		>
			{isCurrentLocation && (
				<img
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							handleClickToOpenModal();
						}
					}}
					src={iconLocation}
					alt="location"
				/>
			)}

			<div onClick={() => handleClickToOpenModal()}>
				<p className="location">{location}</p>
				{obsRead !== undefined && <p className="obs">Obs Read: {obsRead}</p>}
			</div>

			{showFavButton && (
				<FavCityButton
					locationId={locationId}
					locationNameAr={cityNameAr}
					locationNameEn={cityNameEn}
					showFavEmpty={true}
					isDisabled={false}
				/>
			)}

			<button onClick={() => openModal()}>
				<img src={searchIcon} alt="search icon" />
			</button>
		</div>
	);
};

export default SearchBarResult;
